package signSymptom.components

import antd.MouseEvent
import antd.card.card
import antd.grid.col
import antd.grid.row
import antd.message.message
import antd.statistic.statistic
import antd.typography.title
import com.jingfangpai.common.orm.mapping.SignSymptom
import external.pinyin.Pinyin
import kotlinext.js.js
import react.*
import react.dom.a
import react.dom.attrs
import react.dom.div
import signSymptom.containers.SignSymptomListPageContext
import urlBase

external interface SignSymptomListProps : RProps {

}

val SignSymptomList = functionalComponent<SignSymptomListProps> { props ->

    val ctx = useContext(SignSymptomListPageContext)

    val (pinyinSymptomMap,setPinySignSymptomMap) = useState(hashMapOf<String,Array<SignSymptom>>())

    fun getSignSymptomList(){
        ctx.getSignSymptomList({ resp->
            if(resp.ok()){

                val _pinyinSymptomMap = hashMapOf<String,Array<SignSymptom>>()
                resp.data!!.forEach {
                    var initialPinyin = it.nameAbbr?:""
                    if(initialPinyin.isNullOrBlank()){
                        try {
                            val spell = Pinyin.getSpell(it.name?.getLiteral()?:"",null,null)
                            console.log(spell)
                            if(spell.startsWith("[")){
                                val spells = spell.replace("[","").replace("]","").split(",")
                                initialPinyin = spells[0].substring(0,1).uppercase() //默认第1个
                            }else{
                                initialPinyin = spell.substring(0,1).uppercase()
                            }
                        } catch (e: Exception) {
                            console.error("Pinyin conversion failed:", e)
                            // Fallback: use first character as key
                            initialPinyin = it.name?.getLiteral()?.substring(0, 1) ?: "?"
                        }
                    }else{
                        initialPinyin = initialPinyin.substring(0,1).uppercase()
                    }
                    if(!_pinyinSymptomMap.containsKey(initialPinyin)){
                        _pinyinSymptomMap.put(initialPinyin, arrayOf(it))
                    }else{
                        _pinyinSymptomMap[initialPinyin] = _pinyinSymptomMap[initialPinyin]!!.plus(it)
                    }
                }
                setPinySignSymptomMap(_pinyinSymptomMap)
            }else{
                message.error("获取体征症状列表失败:${resp.message}")
            }
        },{
            message.error("获取体征症状列表失败:${it.message}")
        })
    }

    fun onItemClick(e:MouseEvent<Any>){
        message.info("xxx")
        e.preventDefault()
        e.stopPropagation()
    }

    useEffectOnce {
        getSignSymptomList()
    }

    div("SignSymptomList") {
        card {
            attrs {
                title = "体征症状列表"
                extra = buildElement {
                    a {
                        attrs{
                            target = "_blank"
                            href = SmartTcmRoute.SignSymptomEdit.link.url.replace(":id","new") //"${urlBase}/smartTcm/signSymptom/edit/new"
                        }
                        +"添加"
                    }
                }
            }
            pinyinSymptomMap.toList().sortedBy { it.first }.toMap().forEach { (key, values) ->

                div {
                    title {
                        attrs {
                            level = 2
                        }
                        +"${key}"
                    }
                    row {
                        values.forEach { signSymptom ->

                                a{
                                    this.attrs{
                                        href="${SmartTcmRoute.SignSymptomDetail.link.url.replace(":id",signSymptom.id?:"")}"
                                    }
                                    col {
                                        card {
                                            statistic {
                                                attrs {
                                                    value = "${signSymptom.name ?: ""}"
                                                    valueStyle = js{
                                                        color = "#3f8600"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }

                        }
                    }
                }
            }
        }

    }
}
